import PropTypes from 'prop-types';
import React from 'react';
import Calendar from '../../SvgIcon/Icons/Calendar';
import GefTextFieldWrapper from '../GefTextFieldWrapper';
export const createCommonProps = ({ displayValue, onAccept, onChange, clearable, controlPanelIconOpen = /*#__PURE__*/ React.createElement(Calendar, null), popoverParent = document.body, PopoverProps = {}, ...other })=>({
        autoOk: true,
        labelFunc: displayValue !== undefined ? ()=>displayValue : undefined,
        onAccept: (date)=>onAccept?.(null, date),
        TextFieldComponent: GefTextFieldWrapper,
        TextFieldProps: {
            clearable,
            onChange,
            controlPanelIconOpen
        },
        PopoverProps: {
            container: popoverParent,
            ...PopoverProps
        },
        onChange,
        variant: 'inline',
        ...other
    });
export const commonPropTypes = {
    /**
	 * If true, clear button is shown.
	 */ clearable: PropTypes.bool,
    /**
	 * Control pane open icon node
	 */ controlPanelIconOpen: PropTypes.node,
    /**
	 * Value show for input field
	 */ displayValue: PropTypes.string,
    /**
	 * Callback function that fires when value is selected
	 *
	 * @param {Object} event blur event
	 * @return {null} Nothing
	 */ onAccept: PropTypes.func,
    /**
	 * Callback function that allows you to react on text field change event.
	 *
	 * @param {Object} event change event
	 * @return {null} Nothing
	 */ onChange: PropTypes.func,
    /**
	 * custom onClear handler defaulted to TextField onChange.
	 *
	 * @return {null} Nothing
	 */ handleClearChange: PropTypes.func,
    /**
	 * When true, picker will open only by clicking on icon
	 */ openOnlyByIcon: PropTypes.bool,
    /**
	 * HTML element, component instance, or function that returns either. Will be used as a parent for Popover component.
	 * Default is document.body
	 */ popoverParent: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.element,
        PropTypes.node
    ])
};
